import { TokenizeResult } from '@angular/compiler/src/ml_parser/lexer';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangePasswordComponent } from 'app/authentication/change-password/change-password.component';
import { LeaveApplicationComponent } from 'app/main/transaction/leave-application/leave-application.component';
import { navigation } from 'app/navigation/navigation';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { Settings } from 'app/shared/constants/settingDate.constant';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { SharedService } from 'app/shared/service/shared.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import * as _ from 'lodash';
import { parse } from 'path';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AllNotificationDto } from 'shared/service-proxies/models/all-notification-dto.model';
import { AuthenticatedUserDto } from 'shared/service-proxies/models/authenticated-user-dto.model';
import { CompanyEntity } from 'shared/service-proxies/models/company-entity.model';
import { Employee_Dashboard_Instruction_Detail } from 'shared/service-proxies/models/employee-dashboard-instruction-detail.model';
import { EmployeeDashboardServiceProxy } from 'shared/service-proxies/services/employee-dashboard.service';
import { GetAllNotificationByUserIdServiceProxy } from 'shared/service-proxies/services/get-all-notification-by-user-id.service';
import { NotifiationServiceProxy } from 'shared/service-proxies/services/notifiation.service';
import { NotificationServiceProxy } from 'shared/service-proxies/services/notification.service';
import { UserServiceProxy } from 'shared/service-proxies/services/user.service';



@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ToolbarComponent implements OnInit, OnDestroy {
    //@ViewChild('changePasswordComponent', { static: true }) changePasswordComponent: ChangePasswordComponent;
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    userCompany: CompanyEntity[] = [];
    selectedCompany: string = '';
    userName: any;
    profileImage: any;
    currentUser: AuthenticatedUserDto = new AuthenticatedUserDto();
    isAdmin: boolean = true;
    userId: any;
    allNotification: AllNotificationDto[] = [];
    dateTimeformat = Settings.dateTimeformat;
    timeFormat = Settings.timeFormat;
    calendarDateFormat = Settings.calendarDateFormat;
    isActive: boolean;
    isArchive: boolean = false;
    loginAsUser: boolean = false;
    notificationLength: number;
    instructionDetail: any;
    @ViewChild('op', { static: false }) op;
    @ViewChild(LeaveApplicationComponent) leaveApplication: LeaveApplicationComponent;
    // Private
    private _unsubscribeAll: Subject<any>;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */


    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _userServiceProxy: UserServiceProxy,
        private _authenticationService: AuthenticationService,
        private _sharedService: SharedService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _notification: GetAllNotificationByUserIdServiceProxy,
        private _readAllnotification: NotificationServiceProxy,
        private _confirmationService: ConfirmationService,
        private _toasterService: ToasterService,
        private ngZone: NgZone,
        private _dashboardService: EmployeeDashboardServiceProxy
    ) {
        this.isActive = true;

        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this._localStorageService.getData(LocalStorage.TOKEN)) {
            this.currentUser = this._localStorageService.getData(LocalStorage.CURRENT_USER);
            // this.profileImage = this.currentUser.profileImageUri;
            this.userName = this.currentUser.fullName;
            this.isAdmin = this._authenticationService.isAdministrator();
            this.getCompanyList();
            this.getAllNoticationByUserId(true);
        }
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang });


        if (this._localStorageService.getData(LocalStorage.MAIN_USER)) {
            this.loginAsUser = true;
        }
        if (this._authenticationService.isAuthenticated()) {
            this.getInstructionDetail();
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    onNotificationClick() {
        if (this.isActive) {
            this.getAllNoticationByUserId(true);
        }
    }

    getAllNoticationByUserId(active: boolean) {
        this.userId = this._authenticationService.CurrentUserId();
        this._notification.active(this.userId, active).subscribe(response => {
            if (response.isSuccess) {
                this.isActive = active;
                this.allNotification = response.responseData;
                this.allNotification.map(x => x.createdOn = this._sharedService.getlocalDatetime(x.createdOn));
                if (active == true) {
                    this.isArchive = false;
                    this.notificationLength = response.responseData.length;
                }
                else if (active == false)
                    this.isArchive = true;
                this._changeDetectorRef.detectChanges();
            }
        })
    }

    getInstructionDetail() {
        this._dashboardService.getEmployeeInstructionDetail().subscribe(response => {
            if (response.isSuccess) {
                this.instructionDetail = response.responseData;
            }
        })
    }

    markdata() {
        if (this.allNotification.length > 0) {
            this._confirmationService.confirm({
                message: `Are you sure you want to Read All Notification ?`,
                header: 'Confirm',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this._readAllnotification.readAllNotification(this.userId).subscribe(response => {
                        if (response.isSuccess) {
                            this.getAllNoticationByUserId(this.isActive);
                            this.notificationLength = 0;
                        }
                        else {
                            this._toasterService.showApiValidation(response);
                        }
                    })
                }
            });
        }


    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...

    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    /**
    * On logout
    */
    onLogout() {
        this._sharedService.UserLogout();
    }

    getCompanyList() {
        this._userServiceProxy.getUserCompany().subscribe(response => {
            if (response.isSuccess) {
                this.userCompany = response.responseData;
                let companyID = this._authenticationService.CurrentUserCompanyId()
                if (isNaN(Number(companyID))) {
                    this.selectedCompany = "All Companies";
                }
                else {
                    this.selectedCompany = this.userCompany.filter(x => x.id == Number(companyID))[0].companyName;
                }
            }
            this._changeDetectorRef.detectChanges();
        });
    }

    onCompanyChange(companyId: number) {

        let selectedCompnayId = this.selectedCompany !== 'All Companies' ? this.userCompany.filter(x => x.companyName == this.selectedCompany)[0].id : 0;
        if (companyId !== selectedCompnayId) {
            if (companyId == 0) {
                this.selectedCompany = 'All Companies'
            }
            else {
                this.selectedCompany = this.userCompany.filter(x => x.id == companyId)[0].companyName;
            }
            this._userServiceProxy.companyAuthenticateToken(companyId).subscribe(response => {
                if (response.isSuccess) {
                    this._localStorageService.setData(LocalStorage.CURRENT_USER, response.responseData);
                    this._localStorageService.setData(LocalStorage.TOKEN, response.responseData.token);
                    window.location.reload();
                }
            });
        }
    }

    changeuser() {
        this._sharedService.changeUsernamePopup(true);
        this._changeDetectorRef.detectChanges();
    }
    changePass() {
        this._sharedService.changePasswordPopup(true);
        this._changeDetectorRef.detectChanges();
    }
    myprofile() {
        this._router.navigate(['my-profile']);
    }
    readNotification(id) {
        this._readAllnotification.updateNotification(id).subscribe(response => {
            if (response.isSuccess) {
                this.getAllNoticationByUserId(this.isActive);
            }
        })
    }
    redirect(notification: AllNotificationDto) {
        this.op.hide();
        this.readNotification(notification.id);
        this._sharedService.referenceNo = notification.referenceNo as any;
        this._sharedService.redirectNotification(notification.pageName);
        if (notification.pageName == "thumb-application") {
            this._router.navigate([`transaction/${notification.pageName}`]);
        }
        else if (notification.pageName == "leave-application")
            this._router.navigate([`transaction/${notification.pageName}`]);

        else if (notification.pageName == "over-time-application")
            this._router.navigate([`transaction/${notification.pageName}`]);

        else if (notification.pageName == "resign-application")
            this._router.navigate([`transaction/${notification.pageName}`]);

        else if (notification.pageName == "salary-report")
            this._router.navigate([`report/${notification.pageName}`]);

        else if (notification.pageName == "work-from-home") {
            this._router.navigate([`transaction/${notification.pageName}`]);
        }
        else if (notification.pageName == "clarification-application")
            this._router.navigate([`transaction/${notification.pageName}`]);
        else if (notification.pageName == "fuel-allowance-application")
            this._router.navigate([`transaction/${notification.pageName}`]);
        else if (notification.pageName == "compensation-application")
            this._router.navigate([`transaction/${notification.pageName}`]);
    }

    get GetprofileImage() {
        this.profileImage = this._localStorageService.getData(LocalStorage.PROFILE)
        return this.profileImage;
    }

    backToMyAccount() {
        if (this.loginAsUser) {
            let mainUser = this._localStorageService.getData(LocalStorage.MAIN_USER)
            this._localStorageService.setData(LocalStorage.CURRENT_USER, mainUser);
            this._localStorageService.setData(LocalStorage.TOKEN, mainUser.token);
            this._localStorageService.setData(LocalStorage.PROFILE, mainUser.profileImageUri);
            this._localStorageService.deleteData(LocalStorage.MAIN_USER);
            this.loginAsUser = false;
            window.location.href = "/utility/user";
        }
    }
}
